<template lang="pug">
    .md-content
        PmBreadcrumbs(:view="lenguageSelected.breadcrumb", :section="section", :lang="lenguage")
        PmBanner(:name="lenguageNavSelected.title", :image="banner")
        .container
            .row.careers.custom-padding-top
                .col-md-9.products-template-content.no-margin-bottom.custom
                    .contact-content
                        p   {{ lenguageSelected.content1 }}
                        p   {{ lenguageSelected.content2 }}
                        br
                        a.button-submit(href="https://login.global.datasite.com/login/?flowId=Hqh3c") {{ lenguageSelected.content3 }}

                PmContactTable(:lang="lenguage")
                
</template>

<script>
import PmBreadcrumbs from '@components/atoms/PmBreadCrumbs.vue'
import PmContactTable from '@components/molecules/PmContactTable.vue'
import PmBanner from '@components/atoms/PmBanner.vue'
import PmContentBox from '@components/atoms/PmContentBox.vue'
import PmSidebar from '@components/atoms/PmSidebar.vue'
import VueRecaptcha from 'vue-recaptcha';

import contactBanner from '@img/contact/Banner_CONTACT.jpg'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang;
    },
    components: {
        PmBreadcrumbs, PmBanner, PmContentBox, PmSidebar, VueRecaptcha, PmContactTable
    },
    mounted: function(){
        this.$data.section = this.$route.name;
        let to = this.moveToDown ? this.$refs.description.offsetTop - 60 : 0
        window.scroll({
            top: to,
            left: 0,
            behavior: 'smooth'
        })
        this.moveToDown = !this.moveToDown
    },

   

    data: function(){
        return{
            sendState: 'normal',
            banner: contactBanner,
            section: '',
            enContent: {
                title: 'INVESTORS'
            },
            esContent: {
                title: 'Inversionistas'
            },

            lenguage: 'ES',
            lenguageEN: {
                breadcrumb: {name:'Investors', link:'/en/investors'},
                content1: 'Contact Investor Relations:',
                content2: 'investors@atpsites.com',
                content3: 'INVESTOR PORTAL LOGIN',
                


            },

            lenguageES: {
                breadcrumb: {name:'Inversionistas', link:'/es/inversionistas'},
                content1: 'Comuníquese con Relaciones con Inversionistas:',
                content2: 'investors@atpsites.com',
                content3: 'INVESTOR PORTAL LOGIN',
                
            },
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        },
        lenguageNavSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.enContent : this.$data.esContent
        }
    }
}
</script>

<style lang="scss" scoped>
    .error{
        color: red;
        font-size: 11px;
    }
    a.button-submit {
    background-color: red;
    color: white!important;
    padding: 10px 20px;
    text-decoration: none;
    border-radius: 0px;
}
</style>




// WEBPACK FOOTER //
// src/components/organisms/PmInvestors.vue